import { EmailDeliveryTab } from '../models/email-delivery-tab.enum';
import {
  EmailDeliveryHubFailedFilters,
  EmailDeliveryHubPendingFilters,
  EmailDeliveryHubSentFilters,
} from '../models/email-delivery-hub-filters.models';
import { PmsSyncPollingState } from './email-delivery-hub.model';

export class UpdateSentFilters {
  static readonly type = '[EmailDeliveryHub] update filters';

  constructor(public readonly filters: Partial<EmailDeliveryHubSentFilters>) {}
}

export class LoadMetrics {
  static readonly type = '[EmailDeliveryHub] load metrics';
}

export class LoadLastRefresh {
  static readonly type = '[EmailDeliveryHub] load last refresh';

  constructor(public readonly forceRefresh = false) {}
}

export class LoadSettings {
  static readonly type = '[EmailDeliveryHub] load settings';

  constructor(public readonly forceRefresh = false) {}
}

export class UpdatePendingFilters {
  static readonly type = '[EmailDeliveryHub] update pending filters';
  constructor(public readonly filters: EmailDeliveryHubPendingFilters) {}
}

export class UpdateFailedFilters {
  static readonly type = '[EmailDeliveryHub] update failed filters';
  constructor(public readonly filters: EmailDeliveryHubFailedFilters) {}
}

export class LoadPmsSyncStatus {
  static readonly type = '[EmailDeliveryHub] load pms sync status';

  constructor(public readonly forceRefresh = false) {}
}

export class UpdatePmsSyncPollingState {
  static readonly type = '[EmailDeliveryHub] update pms sync polling state';

  constructor(public readonly state: PmsSyncPollingState) {}
}

export class SetActiveTab {
  static readonly type = '[EmailDeliveryHub] set active tab';

  constructor(public readonly tab: EmailDeliveryTab) {}
}
